export const setShades = (shades) => ({
  type: 'SET_SHADES',
  payload: shades,
});

export const setSelectedShadesIndex = (shadesIndex) => ({
  type: 'SET_SELECTED_SHADES_INDEX',
  payload: shadesIndex,
});
